import { Divider } from 'antd';
import { Icon } from '../../components/icon/icon';
import ButtonLink from '../../components/common/ButtonLink/ButtonLink';
import Tag from '../../components/common/Tag/Tag';
import { Flex } from 'antd';
import { Steps } from 'antd';
import { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchOrder, updateOrder } from '../../store/actions/room.action';
import { useParams } from 'react-router-dom';
import { Spin } from 'antd';
import DrawerDetailModule from '../CartPage/components/DrawerDetailModule/DrawerDetailModule';
import ButtonIconGhostMedium from '../../components/common/ButtonIconGhost/ButtonIconGhostMedium';
import { useNavigate } from 'react-router-dom';
import formatDateTime, {
  isDate,
  isTime,
} from '../../utils/dayjs/formatDateTime.util';
import { useTranslation } from 'react-i18next';
import ButtonPrimaryMedium from '../../components/common/ButtonPrimary/ButtonPrimaryMedium';
import ROUTER from '../../routers/Routers';
import {
  fetchFullAddress,
  fetchListAddress,
} from '../../store/actions/address.action';
import ButtonIconOutlineMedium from '../../components/common/ButtonIconOutline/ButtonIconOutlineMedium';
import { cn } from '../../utils/string/cn.utils';
import ButtonSecondaryLarge from '../../components/common/ButtonSecondary/ButtonSecondaryLarge';
import { openModal } from '../../components/common/Modal/openModal';
import { Form } from 'antd';
import { Radio } from 'antd';
import useModalAddress from '../../components/common/ModalAddress/ModalAddress';
import ButtonPrimaryLarge from '../../components/common/ButtonPrimary/ButtonPrimaryLarge';
import ButtonSecondaryMedium from '../../components/common/ButtonSecondary/ButtonSecondaryMedium';
import { openMessageSuccess } from '../../components/common/Message/openMessageSuccess';
import { STATUS_OPTIONS } from '../../constants/constant';
import { Empty } from 'antd';
import { getValueFromString } from '../../utils/data/getValue.utils';
import { parseJson } from '../../utils/string/parseJson';
import { convertForeignCurrency } from '../../utils/currency/currency.utils';

const DetailOrderPage = () => {
  const country_code = process.env.REACT_APP_COUNTRY_CODE ?? 'vn';
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const { order } = useSelector(state => state.room);
  const { user } = useSelector(state => state.auth);
  const { listAddress, provinces, wards } = useSelector(state => state.address);

  const [detailItems, setDetailItems] = useState();
  const [imageList, setImageList] = useState();
  // const [statusItems, setStatusItems] = useState([]);
  // const [amountPay, setAmountPay] = useState({
  //   total: 0,
  //   total1: 0,
  //   total2: 0,
  //   total3: 0,
  // });

  const {
    handleData,
    openModalListAddress,
    deliveryAddress,
    setDeliveryAddress,
    form: formAddress,
    listAdd,
    setListAdd,
    // setListAdd,
  } = useModalAddress({
    handleUpdateAddress: addressId => {
      dispatch(
        updateOrder({ billAddress: addressId, id: order.detail.id })
      ).then(action => {
        if (action.payload?.data) {
          openMessageSuccess({ content: t('Successfully') });
        }
      });
    },
  });

  // const renderCoupons = () => {
  //   if (order.detail?.coupon_codes === undefined) return;
  //   const couponList = parseJson(order.detail?.coupon_codes);
  //   let totalCoupon = 0;
  //   return (
  //     <>
  //       {couponList
  //         ?.filter(item => item.result)
  //         ?.map((coupon, index) => {
  //           totalCoupon += coupon.amount;
  //           return (
  //             <Tag
  //               key={index}
  //               className="bg-[#E3EFFB] text-[#145B90] items-center flex gap-[4px] px-[8px] py-[4px] rounded-[4px]"
  //               label={
  //                 <>
  //                   <span className="flex w-[16px] h-[16px]">
  //                     <Icon.ICVoucher />
  //                   </span>
  //                   <span className="text-label-medium font-semibold">
  //                     {coupon.code}
  //                   </span>
  //                 </>
  //               }
  //             />
  //           );
  //         })}
  //       <span className="text-body-medium font-semibold">
  //         -
  //         {order.detail?.discount?.toLocaleString('vi-VN', {
  //           style: 'currency',
  //           currency: 'VND',
  //         })}
  //       </span>
  //     </>
  //   );
  // };

  const renderProductItem = useCallback(() => {
    if (order.detail?.items === undefined) return;
    const itemList = parseJson(order.detail?.items ?? '[]');
    return itemList?.map((item, index) => {
      // const total =
      //   (item.total_accessory_price ?? 0) +
      //   (item.total_backsplash_price ?? 0) +
      //   (item.total_countertop_price ?? 0) +
      //   (item.total_wood_price ?? 0);
      return (
        <div key={index} className="flex items-center gap-[16px] self-stretch">
          <div className="flex items-center gap-[24px] grow">
            <div
              className="flex w-[60px] h-[60px] aspect-square rounded-[4px] opacity-60"
              style={{
                background: `url(${item.thumbnail}) center/cover no-repeat`,
              }}
            />
            <span className="text-body-large font-semibold grow">
              {getValueFromString(item.item_name)}
            </span>
          </div>
          <span className="text-body-medium font-semibold">x1</span>
          <span className="text-body-medium">
            {convertForeignCurrency(item.price_after)}
          </span>
          {item.data ? (
            <ButtonLink
              title={t('View details')}
              className="text-[#258FD2]"
              onClick={() => {
                try {
                  setDetailItems(item.data);
                  setImageList([item.thumbnail, item.image]);
                } catch {
                  // ignore error
                }
              }}
            />
          ) : (
            <></>
          )}
        </div>
      );
    });
  }, [order.detail]);

  const checkMethodPayment = key => {
    // if (['QR'].includes(key)) return 'Pay via QR code';
    // if (['VISA', 'MASTERCARD', 'JCB'].includes(key)) return 'Credit/Debit Card';
    // return 'Domestic ATM card';
    if (!key) return '--';
    if (['MC'].some(item => key?.includes(item))) return 'Credit/Debit Card';
    if (['VC'].some(item => key?.includes(item))) return 'Credit/Debit Card';
    if (['9704'].some(item => key?.includes(item))) return 'Domestic ATM card';
    return 'Pay via QR code';
  };

  const renderPaymentTransaction = () => {
    const paymentList = (() => {
      try {
        return parseJson(order.detail?.payment_transactions ?? '[]');
      } catch (error) {
        return order.detail?.payment_transactions;
      }
    })();

    let transactions = [];
    order.detail?.payment_installments?.forEach((item, index) => {
      const transaction = paymentList[index];
      const firstIndexPendingInstallment =
        order.detail?.payment_installments?.findIndex(
          item => item.status === 'pending'
        );

      transactions.push(
        <CardTransaction
          key={index}
          title={
            index === 0
              ? t('1st Installment')
              : index === 1
                ? t('2nd Installment')
                : index === 2
                  ? t('3rd Installment')
                  : t('{x}th Installment', { x: index + 1 })
          }
          tag={
            item.status === 'paid' ? (
              <Tag
                className={
                  'flex py-[4px] px-[6px] items-center gap-[6px] rounded-[1000px] bg-[#49AC3E]'
                }
                label={
                  <span className="text-label-medium font-semibold text-white">
                    {t('Completed payment')}
                  </span>
                }
              />
            ) : (
              <Tag
                className={
                  'flex py-[4px] px-[8px] items-center gap-[6px] rounded-[1000px] bg-[#F97D16]'
                }
                label={
                  <span className="text-label-medium font-semibold text-white">
                    {t('Pending payment')}
                  </span>
                }
              />
            )
          }
          amount={convertForeignCurrency(item?.amount)}
          paid={
            !(
              item.status !== 'pending' ||
              firstIndexPendingInstallment === index
            ) || item.status === 'paid'
          }
          paidDate={formatDateTime(item.paid_at, 'dateFormat.dateTime')}
          methodPayment={checkMethodPayment(
            transaction?.raw_response?.vpc_Card
          )}
        />
      );
    });
    return (
      <>
        {transactions.length ? (
          transactions
        ) : (
          <div className="flex items-center justify-center self-stretch grow">
            <Empty />
          </div>
        )}
      </>
    );
  };

  const openModalCancel = () => {
    const modal = openModal({
      title: (
        <div className="flex py-[32px] px-[24px] flex-col justify-center items-center self-stretch bg-[#F7F7F7] h-[168px]">
          <img src="/assets/icons/ic-cancel.svg" alt="" />
        </div>
      ),
      content: (
        <>
          <span className="text-headline-small">
            {t('Do you want to cancel the order?')}
          </span>
          <div className="flex flex-col items-start gap-[16px] self-stretch">
            <span className="text-body-medium">
              {t(
                'The order has not left the warehouse yet, so you can still cancel it. This action cannot be undone, but you can always place a new order at any time.'
              )}
            </span>
          </div>
        </>
      ),
      centered: true,
      width: 538,
      classNames: {
        header: '!m-[0px]',
        body: 'flex !p-[24px] flex-col items-start gap-[24px] self-stretch',
        footer: 'flex items-start gap-[24px] self-stretch !p-[24px]',
      },
      closable: false,
      footer: (
        <>
          <ButtonSecondaryLarge
            className={'warning w-full'}
            title={t('Cancel order')}
            onClick={() => {
              dispatch(
                updateOrder({ fulfillmentStatus: 8, id: order.detail.id })
              ).then(action => {
                if (action.payload?.data) {
                  openMessageSuccess({ content: t('Successfully') });
                }
              });
              modal.destroy();
            }}
          />
          <ButtonSecondaryLarge
            title={t('Keep the order')}
            className={'w-full'}
            onClick={() => modal.destroy()}
          />
        </>
      ),
    });
  };

  const openModalUnAllowCancel = () => {
    const modal = openModal({
      title: (
        <div className="flex py-[32px] px-[24px] flex-col justify-center items-center self-stretch bg-[#F7F7F7] h-[168px]">
          <img src="/assets/icons/ic-nocancel.svg" alt="" />
        </div>
      ),
      content: (
        <>
          <span className="text-headline-small">
            {t('Cannot cancel the order')}
          </span>
          <div className="flex flex-col items-start gap-[16px] self-stretch">
            <span className="text-body-medium">
              {t(
                'This order includes products designed via the App and custom-made according to your requirements, so it cannot be canceled. Please contact customer service if you need assistance.'
              )}
            </span>

            <ButtonLink
              title={t('Order cancellation policy')}
              icon={<Icon.ICOpenNewTab />}
              className={'text-[#258FD2]'}
            />
          </div>
        </>
      ),
      centered: true,
      width: 538,
      classNames: {
        header: '!m-[0px]',
        body: 'flex !p-[24px] flex-col items-start gap-[24px] self-stretch',
        footer: 'flex items-start gap-[24px] self-stretch !p-[24px]',
      },
      closable: false,
      footer: (
        <>
          <ButtonPrimaryLarge
            title={t('Contact support')}
            className={'w-full'}
            onClick={() => window.open('tel:0941446571')}
          />
        </>
      ),
    });
  };

  const openModalSupport = () => {
    const modal = openModal({
      title: (
        <div className="flex py-[32px] px-[24px] flex-col justify-center items-center self-stretch bg-[#F7F7F7] h-[168px]">
          <img src="/assets/icons/ic-cancel.svg" alt="" />
        </div>
      ),
      content: (
        <>
          <span className="text-headline-small">{t('Contact support')}</span>
          <div className="flex flex-col items-start gap-[12px] self-stretch">
            <div className="flex py-[24px] px-[40px] items-center gap-[40px] self-stretch rounded-[16px] bg-[#EDFAFF]">
              <div className="flex flex-col justify-center items-start gap-[6px] grow">
                <span className="text-body-medium">{t('Hotline')}</span>
                <span className="text-title-small !font-bold">
                  0941 446 571
                </span>
              </div>
              <ButtonSecondaryMedium
                posIcon={<Icon.ICPhone />}
                title={t('Call hotline')}
                onClick={() => window.open('tel:0941446571')}
              />
            </div>
            <div className="flex py-[24px] px-[40px] items-center gap-[40px] self-stretch rounded-[16px] bg-[#EDFAFF]">
              <div className="flex flex-col justify-center items-start gap-[6px] grow">
                <span className="text-body-medium">Email {t('Support')}</span>
                <span className="text-title-small !font-bold">
                  info@fittamodular.com
                </span>
              </div>
              <ButtonSecondaryMedium
                posIcon={<Icon.ICPhone />}
                title={t('Send support email')}
                onClick={() => window.open('mailto:info@fittamodular.com')}
              />
            </div>
          </div>
        </>
      ),
      centered: true,
      width: 538,
      classNames: {
        header: '!m-[0px]',
        body: 'flex !p-[24px] flex-col items-start gap-[24px] self-stretch',
        footer: '',
      },
      closable: false,
      footer: <></>,
    });
  };

  const renderFulfillmentStatus = (orderType, status) => {
    switch (status) {
      case 6:
        return orderType === 2
          ? t(STATUS_OPTIONS[9])
          : t(STATUS_OPTIONS[status]);
      case 7:
        return t(STATUS_OPTIONS[9]);
      default:
        return t(STATUS_OPTIONS[status]);
    }
  };

  // const analyzeTimeline = (history, timeline) => {
  //   const tempStatusItems = [];

  //   history.forEach(item => {
  //     let step = item[0];
  //     let startTime = item[1] ?? '';
  //     let endTime = !['00:00', null].some(i => item[2] === i) ? item[2] : '';
  //     let description = `${startTime}, ${endTime}`;
  //     if (
  //       Number(order.detail?.order_type ?? 0) === 2 &&
  //       ![0, 1, 4, 5, 6].includes(step)
  //     ) {
  //       return;
  //     }
  //     if (
  //       [2].includes(step) &&
  //       ![2, 3].some(item => order.detail?.order_type === item)
  //     ) {
  //       startTime = timeline[step - 2]?.startDatePlan;
  //       endTime = timeline[step - 2]?.endDatePlan;
  //     }
  //     if (
  //       [3].includes(step) &&
  //       !(Number(order.detail?.order_type ?? 0) === 2)
  //     ) {
  //       startTime = timeline[step - 2]?.startDatePlan;
  //       endTime = timeline[step - 2]?.endDatePlan;
  //     }

  //     if (![0, 1, 6].includes(step)) {
  //       description = (
  //         <div className="flex flex-col items-start justify-start gap-[2px]">
  //           <span className="text-body-small">{startTime}</span>
  //           <span className="text-body-small">{endTime}</span>
  //         </div>
  //       );
  //     }

  //     if (step === 4 && history.some(i => i[0] === 5)) {
  //       startTime = timeline[2]?.startDatePlan;
  //       endTime = timeline[2]?.endDatePlan;
  //       description = (
  //         <div className="flex flex-col items-start justify-start gap-[2px]">
  //           <span className="text-body-small">{startTime}</span>
  //           <span className="text-body-small text-[#258FD2]">{`${endTime} - ${t('Received')}`}</span>
  //         </div>
  //       );
  //     }
  //     if (step === 5) {
  //       startTime = timeline[3]?.startDatePlan;
  //       endTime = timeline[3]?.endDatePlan;
  //       description = (
  //         <div className="flex flex-col items-start gap-[2px] text-black/60">
  //           <span className="text-body-small">{`${startTime}`}</span>
  //           <span className="text-body-small text-[#258FD2]">{`${endTime} - ${t('Installed')}`}</span>
  //         </div>
  //       );
  //     }

  //     applyStatusToSteps(tempStatusItems, {
  //       title: t(STATUS_OPTIONS[step]),
  //       description,
  //       status: step === 8 ? 'error' : 'finish',
  //     });
  //     if (step === 5) {
  //       applyStatusToSteps(tempStatusItems, {
  //         title: t(STATUS_OPTIONS[6]),
  //         description: <></>,
  //         status: 'finish',
  //       });
  //     }
  //   });

  //   (Number(order.detail?.order_type ?? 0) === 2
  //     ? [0, 1, 4, 5, 6]
  //     : Number(order.detail?.order_type ?? 0) === 3
  //       ? [0, 1, 3, 4, 5, 6]
  //       : [0, 1, 2, 3, 4, 5, 6]
  //   )
  //     .filter(index => {
  //       return (
  //         !history.some(item => item[0] === index) &&
  //         !(history.some(item => item[0] === 5) && index === 6)
  //       );
  //     })
  //     .forEach((index, i) => {
  //       let description = null;
  //       let startTime = null;
  //       let endTime = null;
  //       if (index === 2) {
  //         startTime = timeline[0]?.startDatePlan;
  //         endTime = timeline[0]?.endDatePlan;
  //       } else if (index === 3) {
  //         startTime = timeline[1]?.startDatePlan;
  //         endTime = timeline[1]?.endDatePlan;
  //       } else if (index === 4) {
  //         startTime = timeline[2]?.startDatePlan;
  //         endTime = timeline[2]?.endDatePlan;
  //       } else if (index === 5) {
  //         startTime = timeline[3]?.startDatePlan;
  //         endTime = timeline[3]?.endDatePlan;
  //       }
  //       // else if (index === 6) {
  //       //   startTime = timeline[4]?.startDatePlan;
  //       //   endTime = timeline[4]?.endDatePlan;
  //       // }
  //       description = (
  //         <div className="flex flex-col items-start justify-start gap-[2px]">
  //           <span className="text-body-small">{startTime}</span>
  //           <span className="text-body-small">{endTime}</span>
  //         </div>
  //       );
  //       applyStatusToSteps(tempStatusItems, {
  //         title: t(STATUS_OPTIONS[index]),
  //         description,
  //         status: i === 0 ? 'process' : 'wait',
  //       });
  //     });
  //   return tempStatusItems;
  // };

  useEffect(() => {
    if (id) {
      dispatch(fetchOrder({ id, country_code }));
    }
  }, [id]);

  // useEffect(() => {
  //   if (order.detail) {
  //     const total =
  //       (order.detail?.amount ?? 0) +
  //       (order.detail?.shipping_fee ?? 0) -
  //       (order.detail?.discount ?? 0);
  //     // setAmountPay({
  //     //   total,
  //     //   total1: total * 0.5,
  //     //   total2: total * 0.3,
  //     //   total3: total * 0.2,
  //     // });
  //     const history = order.detail.fulfillment_history_status;
  //     const timeline = order.detail.timeline ?? [];
  //     const tempStatusItems = analyzeTimeline(history, timeline);
  //     setStatusItems(tempStatusItems);
  //   }
  // }, [order.detail]);

  useEffect(() => {
    if (listAdd.length) {
      if (order.detail?.bill_address) {
        const address = listAdd.find(
          item => item.id === order.detail.bill_address
        );
        setDeliveryAddress(address);
      } else {
        setDeliveryAddress(listAdd.find(item => item.is_default));
      }
    }
  }, [order, listAdd]);

  useEffect(() => {
    if (listAddress?.data?.length > 0) {
      setListAdd([...(listAddress.data ?? [])]);
      handleData();
    }
  }, [listAddress]);

  useEffect(() => {
    if (listAddress.isNeedReloadData) dispatch(fetchListAddress());
  }, [listAddress]);

  useEffect(() => {
    formAddress.setFieldValue('deliveryAddress', deliveryAddress?.id);
  }, [deliveryAddress]);

  return (
    <>
      <section className="flex p-[24px] pb-[32px] flex-col items-start gap-[24px] grow rounded-[8px] bg-fills-white">
        <Spin spinning={order.detailIsLoading} fullscreen={true} size="large" />
        <div className="flex items-center gap-[16px] self-stretch">
          <ButtonIconOutlineMedium
            icon={<Icon.ICArrowBack />}
            onClick={() => navigate(ROUTER.ACCOUNT + ROUTER.ORDER)}
          />
          <span className="text-headline-small">{t('Order details')}</span>
        </div>

        <div className="flex items-start gap-[40px] self-stretch">
          <div className="flex flex-col items-start gap-[16px] grow">
            <div className="flex flex-col items-start self-stretch">
              <div className="flex z-1 p-[24px] flex-col items-start gap-[12px] self-stretch rounded-[16px] border-[1px] border-solid border-[#E0E0E0] bg-fills-white">
                <div className="flex items-center gap-[8px] grow">
                  <span className="flex w-[24px] h-[24px]">
                    <Icon.ICCart />
                  </span>
                  <span className="text-title-medium font-semibold">
                    {order.detail?.code}
                  </span>
                </div>
                <Divider type="horizontal" className="m-0 !p-0" />
                <div className="flex flex-col justify-center items-start gap-[12px] self-stretch">
                  <span className="text-body-medium font-semibold">
                    {t('Status')}
                  </span>
                  <div className="flex flex-col items-start gap-[8px] self-stretch">
                    {(() => {
                      const history =
                        order.detail?.fulfillment_history_status ?? [];
                      const temp = history[history.length - 1];
                      const date = temp ? temp[1] : '';
                      const time = temp ? temp[2] : '';
                      const step = temp ? temp[0] : -1;
                      return (
                        <>
                          <span className="text-body-medium font-semibold text-[#006EE5]">
                            {renderFulfillmentStatus(
                              Number(order.detail?.order_type ?? 0),
                              step
                            )}
                          </span>
                          <span className="text-body-medium text-black/60">
                            {`${date} ${time}`}
                          </span>
                        </>
                      );
                    })()}
                  </div>
                </div>
                <Divider type="horizontal" className="m-0 !p-0" />
                <div className="flex flex-col items-start gap-[12px] self-stretch">
                  <span className="text-body-medium font-semibold">
                    {t('Shipping information')}
                  </span>
                  <span className="text-body-medium text-black/60">
                    {`${t('Expected date delivery')} ${formatDateTime(
                      order.detail?.estimated_delivery_date,
                      'dateFormat.date'
                    )}`}
                  </span>
                </div>
                <Divider type="horizontal" className="m-0 !p-0" />
                <div className="flex items-start gap-[12px] self-stretch">
                  <div className="flex flex-col items-start gap-[12px] grow">
                    <span className="text-body-medium font-semibold">
                      {t('Delivery to')}
                    </span>
                    <div className="flex flex-col items-start gap-[8px] self-stretch">
                      <div className="flex items-center gap-8 self-stretch">
                        <span className="text-body-medium font-semibold">
                          {user?.fullname}
                        </span>
                        <Divider
                          type="vertical"
                          className="m-0 !p-0 h-[18px]"
                        />
                        <span className="text-body-medium text-black/60">
                          {user?.phone}
                        </span>
                      </div>
                      {deliveryAddress ? (
                        <span className="text-body-medium text-black/60">
                          {`${deliveryAddress?.addressFull ?? '...'}`}
                        </span>
                      ) : (
                        <></>
                      )}
                    </div>
                  </div>
                  <ButtonIconOutlineMedium
                    icon={<Icon.ICEdit />}
                    onClick={() => {
                      openModalListAddress();
                    }}
                  />
                </div>
              </div>
              {/* {order.detail?.paid_step < 3 ? (
                <div className="flex mt-[-16px] p-[24px] pt-[32px] items-center gap-[32px] self-stretch rounded-b-[16px] bg-[#FFFBEB] justify-between">
                  <span className="text-body-medium">
                    {t(
                      'Your order has been created but payment has not been completed. Please continue with payment to complete your order.'
                    )}
                  </span>
                  <ButtonPrimaryMedium
                    title={t('Pay now')}
                    onClick={() => {
                      if (order.detail) {
                        navigate(ROUTER.PAYMENT, {
                          state: {
                            data: {
                              ...order.detail,
                            },
                          },
                        });
                      }
                    }}
                  />
                </div>
              ) : (
                <></>
              )} */}
            </div>
            <div className="flex p-[24px] flex-col items-start gap-[12px] self-stretch rounded-[16px] border-[1px] border-solid border-[#E0E0E0] bg-fills-white">
              <div className="flex items-start gap-[12px] self-stretch">
                <span className="flex w-[24px] h-[24px]">
                  <Icon.ICProducts />
                </span>
                <span className="text-title-medium font-semibold">
                  {t('Products')}
                </span>
              </div>
              <Divider type="horizontal" className="m-0 !p-0" />
              <div className="flex flex-col items-start gap-[4px] self-stretch">
                {renderProductItem()}
              </div>
              <Divider type="horizontal" className="m-0 !p-0" />
              <div className="flex py-[8px] flex-col items-start gap-[12px] self-stretch">
                <div className="flex justify-between items-center self-stretch">
                  <span className="text-label-large font-semibold">
                    {t('Subtotal')}
                  </span>
                  {/* {renderTempTotal()} */}
                  <span className="text-body-medium font-semibold">
                    {convertForeignCurrency(
                      (order.detail?.amount ?? 0) -
                        (order.detail?.shipping_fee ?? 0) -
                        (order.detail?.discount ?? 0)
                    )}
                  </span>
                </div>
                <div className="flex justify-between items-center self-stretch">
                  <span className="text-label-large font-semibold">
                    {t('Discounts')}
                  </span>
                  <div className="flex items-center gap-[16px]">
                    {(() => {
                      try {
                        if (Array.isArray(order.detail?.coupon_codes)) {
                          return order.detail?.coupon_codes;
                        } else if (
                          typeof order.detail?.coupon_codes === 'string'
                        ) {
                          return JSON.parse(order.detail?.coupon_codes);
                        } else if (
                          typeof order.detail?.coupon_codes === 'string'
                        ) {
                          return JSON.parse(order.detail?.coupon_codes);
                        }
                      } catch (error) {
                        console.log(error);
                        return [];
                      }
                    })()
                      ?.filter(item => item.result)
                      ?.map(item => {
                        return (
                          <Tag
                            key={item.code}
                            label={
                              <div className="flex items-center justify-center gap-[4px]">
                                <span className="flex w-[16px] h-[16px]">
                                  <Icon.ICPercentDiscount />
                                </span>
                                <span className="text-label-medium">
                                  {(() => {
                                    if (item.discount_type === 'percent') {
                                      return t('{{x}}% Off', {
                                        x:
                                          item.discount_type === 'percent'
                                            ? `${item.discount_value || 0}`
                                            : `${convertForeignCurrency(item.discount_value)}`,
                                      });
                                    } else {
                                      return item.code;
                                    }
                                  })()}
                                </span>
                              </div>
                            }
                            className="py-[4px] px-[8px] rounded-[4px] bg-Accents-Red-Fill-Varient text-Accents-On-Red-Fill"
                          />
                        );
                      })}

                    <span className="text-body-medium font-semibold">
                      -
                      {convertForeignCurrency(
                        Number(order.detail?.discount ?? 0)
                      )}
                    </span>
                  </div>
                </div>
                <div className="flex justify-between items-center self-stretch">
                  <span className="text-label-large font-semibold">
                    {t('Shipping fee')}
                  </span>
                  <div className="flex items-center gap-[16px]">
                    {order.detail?.shipping_fee ? (
                      <span className="text-body-medium font-semibold">
                        {convertForeignCurrency(order.detail?.shipping_fee)}
                      </span>
                    ) : (
                      t('Free')
                    )}
                  </div>
                </div>
              </div>
              <Divider type="horizontal" className="m-0 !p-0" />
              <div className="flex items-center gap-[10px] self-stretch justify-between">
                <span className="text-label-large font-semibold">
                  {t('Total price')}
                </span>
                <span className="text-title-medium">
                  {convertForeignCurrency(order.detail?.amount)}
                </span>
              </div>
            </div>
            <div className="flex p-[24px] flex-col items-start gap-[12px] self-stretch rounded-[16px] border-[1px] border-solid border-[#E0E0E0] bg-fills-white">
              <div className="flex items-start gap-[12px] self-stretch">
                <span className="flex w-[24px] h-[24px]">
                  <Icon.ICPayment />
                </span>
                <span className="text-title-medium font-semibold">
                  {t('Payment information')}
                </span>
              </div>
              <Divider type="horizontal" className="m-0 !p-0" />
              {renderPaymentTransaction()}
            </div>
            <div className="flex items-start gap-[24px] self-stretch grow">
              <ButtonSecondaryLarge
                posIcon={<Icon.ICDelete />}
                title={t('Confirm cancel')}
                onClick={() =>
                  order.detail?.order_type === 2
                    ? openModalCancel()
                    : openModalUnAllowCancel()
                }
                disabled={order.detail?.fulfillment_status > 3}
                className={'w-full'}
              />

              <ButtonSecondaryLarge
                posIcon={<Icon.ICSupport />}
                title={t('Support')}
                onClick={() => openModalSupport()}
                className={'w-full'}
              />
            </div>
          </div>

          {/* <Flex gap="middle" className="max-w-[200px]">
            {(() => {
              return (
                <Flex gap="middle" className="max-w-[250px]">
                  <Steps
                    progressDot={(_, info) => {
                      if (info.status === 'finish') {
                        return (
                          <span className="flex w-[16px] h-[16px] absolute right-[-8px] top-[-4px] text-[#49AC3E]">
                            <Icon.ICCheckFill />
                          </span>
                        );
                      } else if (info.status === 'process') {
                        return (
                          <span className="flex w-[16px] h-[16px] absolute right-[-8px] top-[-4px]">
                            <Icon.ICDot />
                          </span>
                        );
                      } else if (info.status === 'wait') {
                        return (
                          <span className="flex w-[16px] h-[16px] absolute right-[-8px] top-[-4px]">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="16"
                              viewBox="0 0 16 16"
                              fill="none"
                            >
                              <circle
                                cx="8"
                                cy="8"
                                r="7"
                                fill="#EDEDED"
                                stroke="#EDEDED"
                                stroke-width="2"
                              />
                            </svg>
                          </span>
                        );
                      } else {
                        return (
                          <span className="flex w-[16px] h-[16px] absolute right-[-8px] top-[-4px]">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="16"
                              viewBox="0 0 16 16"
                              fill="none"
                            >
                              <path
                                d="M5.60016 11.334L8.00016 8.93398L10.4002 11.334L11.3335 10.4007L8.9335 8.00065L11.3335 5.60065L10.4002 4.66732L8.00016 7.06732L5.60016 4.66732L4.66683 5.60065L7.06683 8.00065L4.66683 10.4007L5.60016 11.334ZM8.00016 14.6673C7.07794 14.6673 6.21127 14.4923 5.40016 14.1423C4.58905 13.7923 3.8835 13.3173 3.2835 12.7173C2.6835 12.1173 2.2085 11.4118 1.8585 10.6007C1.5085 9.78954 1.3335 8.92287 1.3335 8.00065C1.3335 7.07843 1.5085 6.21176 1.8585 5.40065C2.2085 4.58954 2.6835 3.88398 3.2835 3.28398C3.8835 2.68398 4.58905 2.20898 5.40016 1.85898C6.21127 1.50898 7.07794 1.33398 8.00016 1.33398C8.92238 1.33398 9.78905 1.50898 10.6002 1.85898C11.4113 2.20898 12.1168 2.68398 12.7168 3.28398C13.3168 3.88398 13.7918 4.58954 14.1418 5.40065C14.4918 6.21176 14.6668 7.07843 14.6668 8.00065C14.6668 8.92287 14.4918 9.78954 14.1418 10.6007C13.7918 11.4118 13.3168 12.1173 12.7168 12.7173C12.1168 13.3173 11.4113 13.7923 10.6002 14.1423C9.78905 14.4923 8.92238 14.6673 8.00016 14.6673Z"
                                fill="#E5654E"
                              />
                            </svg>
                          </span>
                        );
                      }
                    }}
                    direction="vertical"
                    items={statusItems}
                  />
                </Flex>
              );
            })()}
          </Flex> */}
          <Flex gap="middle" className="max-w-[200px]">
            <RenderTimeline />
          </Flex>
        </div>
      </section>
      <DrawerDetailModule
        open={detailItems}
        items={detailItems ?? '[]'}
        onClose={() => {
          setDetailItems(null);
          setImageList(null);
        }}
        imageList={imageList}
      />
    </>
  );
};

export default DetailOrderPage;

const RenderTimeline = () => {
  const { t } = useTranslation();
  const { order } = useSelector(state => state.room);
  const [statusItems, setStatusItems] = useState([]);

  const applyStatusToSteps = (arr, { title, status, description }) => {
    arr.push({
      title: (
        <span className="text-title-smallsmall font-semibold text-black/60">
          {t(title)}
        </span>
      ),
      description: <span className="text-body-small">{description}</span>,
      status,
    });
  };

  const analyzeTimeline = (history, timeline) => {
    const tempStatusItems = [];
    let desTaskCreate;
    let desTaskConfirm;
    if (history[0]) {
      desTaskCreate = history[0][1] ? `${history[0][1]}, ${history[0][2]}` : '';
    }
    if (history[1]) {
      desTaskConfirm = history[1][1]
        ? `${history[1][1]}, ${history[1][2]}`
        : '';
    }
    applyStatusToSteps(tempStatusItems, {
      title: STATUS_OPTIONS[0],
      description: desTaskCreate,
      status: history[0] ? 'finish' : 'process',
    });
    applyStatusToSteps(tempStatusItems, {
      title: STATUS_OPTIONS[1],
      description: desTaskConfirm,
      status: history[1] ? 'finish' : 'process',
    });

    timeline.forEach((item, index) => {
      if (item) {
        const historyCurrentStatus = history.find(
          item => item[0] === index + 2
        );
        const historyPreviousStatus = history.find(
          item => item[0] === index + 1
        );
        applyStatusToSteps(tempStatusItems, {
          title: STATUS_OPTIONS[index + 2],
          description: (
            <div className="flex flex-col items-start justify-start gap-[2px]">
              <span className="text-body-small">{item.startDatePlan}</span>
              <span className="text-body-small">{item.endDatePlan}</span>
            </div>
          ),
          status: historyCurrentStatus
            ? 'finish'
            : historyPreviousStatus
              ? 'process'
              : 'wait',
        });
      }
    });
    const listStatus = [0, 1];
    timeline.forEach((item, index) => {
      if (item) {
        listStatus.push(index + 2);
      }
    });
    const len = history.length;
    const status = history[len - 1]?.[0];
    const indexStatus = listStatus.findIndex(item => item === status);
    applyStatusToSteps(tempStatusItems, {
      title: STATUS_OPTIONS[6],
      description: '',
      status:
        indexStatus === listStatus.length - 1
          ? 'finish'
          : history[5]
            ? 'process'
            : 'wait',
    });
    return tempStatusItems;
  };

  useEffect(() => {
    const length = order.detail?.fulfillment_history_status?.length;
    const status = order.detail?.fulfillment_history_status?.[length - 1]?.[0];

    if (order.detail) {
      const total =
        (order.detail?.amount ?? 0) +
        (order.detail?.shipping_fee ?? 0) -
        (order.detail?.discount ?? 0);
      // setAmountPay({
      //   total,
      //   total1: total * 0.5,
      //   total2: total * 0.3,
      //   total3: total * 0.2,
      // });

      const history = order.detail.fulfillment_history_status;
      const timeline = order.detail.timeline ?? [];
      const tempStatusItems = analyzeTimeline(history, timeline);
      setStatusItems(tempStatusItems);
    }
  }, [order.detail]);

  return (
    <Flex gap="middle" className="max-w-[250px]">
      <Steps
        progressDot={(_, info) => {
          if (info.status === 'finish') {
            return (
              <span className="flex w-[16px] h-[16px] absolute right-[-8px] top-[-4px] text-[#49AC3E]">
                <Icon.ICCheckFill />
              </span>
            );
          } else if (info.status === 'process') {
            return (
              <span className="flex w-[16px] h-[16px] absolute right-[-8px] top-[-4px]">
                <Icon.ICDot />
              </span>
            );
          } else if (info.status === 'wait') {
            return (
              <span className="flex w-[16px] h-[16px] absolute right-[-8px] top-[-4px]">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                >
                  <circle
                    cx="8"
                    cy="8"
                    r="7"
                    fill="#EDEDED"
                    stroke="#EDEDED"
                    stroke-width="2"
                  />
                </svg>
              </span>
            );
          } else {
            return (
              <span className="flex w-[16px] h-[16px] absolute right-[-8px] top-[-4px]">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                >
                  <path
                    d="M5.60016 11.334L8.00016 8.93398L10.4002 11.334L11.3335 10.4007L8.9335 8.00065L11.3335 5.60065L10.4002 4.66732L8.00016 7.06732L5.60016 4.66732L4.66683 5.60065L7.06683 8.00065L4.66683 10.4007L5.60016 11.334ZM8.00016 14.6673C7.07794 14.6673 6.21127 14.4923 5.40016 14.1423C4.58905 13.7923 3.8835 13.3173 3.2835 12.7173C2.6835 12.1173 2.2085 11.4118 1.8585 10.6007C1.5085 9.78954 1.3335 8.92287 1.3335 8.00065C1.3335 7.07843 1.5085 6.21176 1.8585 5.40065C2.2085 4.58954 2.6835 3.88398 3.2835 3.28398C3.8835 2.68398 4.58905 2.20898 5.40016 1.85898C6.21127 1.50898 7.07794 1.33398 8.00016 1.33398C8.92238 1.33398 9.78905 1.50898 10.6002 1.85898C11.4113 2.20898 12.1168 2.68398 12.7168 3.28398C13.3168 3.88398 13.7918 4.58954 14.1418 5.40065C14.4918 6.21176 14.6668 7.07843 14.6668 8.00065C14.6668 8.92287 14.4918 9.78954 14.1418 10.6007C13.7918 11.4118 13.3168 12.1173 12.7168 12.7173C12.1168 13.3173 11.4113 13.7923 10.6002 14.1423C9.78905 14.4923 8.92238 14.6673 8.00016 14.6673Z"
                    fill="#E5654E"
                  />
                </svg>
              </span>
            );
          }
        }}
        direction="vertical"
        items={statusItems}
      />
    </Flex>
  );
};

const CardTransaction = ({
  title,
  tag,
  methodPayment,
  paidDate,
  amount,
  paid = false,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { order } = useSelector(state => state.room);
  return (
    <div className="flex p-[16px] flex-col items-start gap-[8px] self-stretch rounded-[16px] border-[1px] border-solid border-[#E0E0E0] bg-fills-white">
      <div className="flex justify-between items-center self-stretch">
        <span className="text-title-small text-black/80 !font-bold">
          {title}
        </span>
        {tag}
      </div>
      <Divider type="horizontal" className="m-0 !p-0" />
      <div className="flex flex-col items-start gap-[4px] self-stretch">
        <div className="flex h-[24px] items-center justify-between gap-[10px] self-stretch">
          <span className="text-body-medium text-black/60">
            {t('Payment method')}
          </span>
          <span className="text-body-medium text-black/60">
            {methodPayment ?? '--'}
          </span>
        </div>
        <div className="flex h-[24px] items-center justify-between gap-[10px] self-stretch">
          <span className="text-body-medium text-black/60">
            {t('Paid date')}
          </span>
          <span className="text-body-medium text-black/60">
            {paidDate ?? '--'}
          </span>
        </div>
      </div>
      <Divider type="horizontal" className="m-0 !p-0" />
      <div
        className={cn(
          'flex justify-end items-center self-stretch',
          !paid && 'justify-between'
        )}
      >
        {!paid && (
          <ButtonPrimaryMedium
            title={t('Pay now')}
            onClick={() => {
              if (order.detail) {
                navigate(ROUTER.PAYMENT, {
                  state: {
                    data: {
                      ...order.detail,
                    },
                  },
                });
              }
            }}
          />
        )}
        <span className="text-body-large font-semibold text-black/80">
          {amount}
        </span>
      </div>
    </div>
  );
};
